// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zr7Y7","badges":"styles_badges__1dCml"};